export default{
    personalAuth:{
        btnState:{
            btn1:'取消',
            btn2:'保存并提交审核'
        },
        titleList:{
            title1:'身份信息',
            title2:'证件信息',
            title3:'男',
            title4:'女',
            title5:'长期',
            title6:'身份证正面',
            title7:'身份证反面',
            title8:'手持身份证正面照',


        },
        fromtitle:{
            from1:'姓名：',
            from2:'性别：',
            from3:'身份证号码：',
            from4:'身份证有效期：',
            from5:'联系手机：',
        },
        placeholderlist:{
            pla1:'请输入真实姓名',
            pla2:'请输入身份号码',
            pla3:'选择日期',
            pla4:'请输入联系人的手机',
        },
        rulesMessage:{
            rule1:'请上传身份证正面照片',
            rule2:'请上传身份证反面照片',
            rule3:'请上传手持身份证照片',
            rule4:'请输入真实姓名',
            rule5:'请输入2-20个字符的真实姓名',
            rule6:'请输入正确的身份证号',
            rule7:'请选择正确身份有效期',
            rule8:'请输入手机号!',
            rule9:'手机号码输入有误!',
            rule10:'请上传正确的图片格式!',
            rule11:'上传图片大小不能超过10MB哦',
            rule12:'上传个人身份证证件照，图片类型支持jpg、jpeg、png,文件大小限制10M。',
            rule13:'保存成功'
        }
    }
}